import React from "react";
import { Link } from "react-router-dom";
import VK from "../../images/vk-logo.png";
import Phone from "../../images/call.png";
import Online from "../../images/pen.png";
import Programmer from "../../images/coding.png";
import LiveInternetCounter from "./LiveInternetCounter/LiveInternetCounter.js";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__menu">
        <div className="footer__iko">
          <Link to="/">
            <div className="header__logo footer__logo"></div>
          </Link>
          <div className="footer__social">
            <a
              href="https://vk.com/public218001479"
              aria-label="Мы в ВКонтакте"
            >
              <img src={VK} className="footer__social-iko" alt="BK" />
            </a>
            <a href="tel:+73432189586" aria-label="Звонок">
              <img src={Phone} className="footer__social-iko" alt="Трубка" />
            </a>
            <Link to="/#record" aria-label="Запись на прием">
              <img
                src={Online}
                className="footer__social-iko"
                alt="Запись на прием"
              />
            </Link>
            <a href="mailto:gatalsky.d.v@yandex.ru?subject=Письмо%20по%20разработке%20сайта%20urniidvi.ru&body=Добрый%20день!">
              <img
                src={Programmer}
                className="footer__social-iko prog"
                alt="Разработчик"
              />
            </a>
          </div>
        </div>

        <div className="footer__middle">
          <Link to="/about" className="footer__middle-link">
            Об институте
          </Link>
          <Link to="/science" className="footer__middle-link">
            Наука
          </Link>
          <Link to="/education" className="footer__middle-link">
            Образование
          </Link>
        </div>

        <div className="footer__middle">
          <Link to="/clinic" className="footer__middle-link">
            Клиника
          </Link>
          <Link to="/patients" className="footer__middle-link">
            Пациентам
          </Link>
          <Link to="/contacts" className="footer__middle-link">
            Контакты
          </Link>
        </div>
      </div>

      <h3 className="footer__social-text">
        © 2008 – 2026 ГБУ СО «УрНИИДВиИ». Все права защищены.
      </h3>

      <div className="footer__live">
        <h3 className="footer__social-text">
          Копирование информации данного сайта допускается только при условии
          указания ссылки на сайт.
        </h3>
        <div className="footer__liveinternet">
          <LiveInternetCounter />
        </div>
      </div>
    </footer>
  );
}
